<template>
    <div>
        <p><span class="brand-color brand-font center">Please enter your name and email address below.</span></p>
        <form>
            <div class="row">
                <div class="input-field col s6">
                    <input id="first_name" type="text" class="validate" v-model.trim="firstName">
                    <label for="first_name">First Name</label>
                </div>
                <div class="input-field col s6">
                    <input id="last_name" type="text" class="validate" v-model.trim="lastName">
                    <label for="last_name">Last Name</label>
                </div>
            </div>
            <div class="row">
                <div class="input-field col s12">
                    <input id="email" type="email" class="validate" v-model.trim="email">
                    <label for="email">Email</label>
                </div>
            </div>
        </form>

        <div class="btn-caption">
            <button @click.prevent="submit()" class="waves-effect waves-light btn-large brand-font">
                {{ freebie.label }}
            </button>
            <span>{{ freebie.caption }}</span>
        </div>
        <div class="legal center">Privacy Policy: I hate spam and promise to keep your email address safe.</div>
    </div>
</template>

<script>
    export default {
        name: 'email',
        props: ['freebie'],

        data: function () {
            return {
                firstName: '',
                lastName: '',
                email: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            }
        }
        ,

        methods: {
            validEmail: function () {
                return (this.reg.test(this.email)) ? true : false;
            },

            submit: function () {
                let data = {
                    event: 'email',
                    first_name: this.firstName,
                    last_name: this.lastName,
                    email: this.email,
                    freebie: this.freebie.key
                };

                broadcast(data);
            }
        }
    }
</script>